import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Container, Row, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { TextInputform, DropDown, Calender } from "../../components/Forms";
import { Buttons } from "../../components/Buttons";
import CustomModal from "../../components/Modal";
import NotifyData from "../../components/NotifyData";
import { FaCaretRight, FaCreditCard } from "react-icons/fa";
import {
  fetchCollections,
  addCollection,
  updateCollection,
} from "../../slice/CollectionSlice";

const CollectionCreation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { collections, customers, areas, plans } = useSelector(
    (state) => state.collections
  );


  console.log( customers);

  const userData = JSON.parse(localStorage.getItem("user")) || {};
  const currentUserId = userData.user_id;

  const isEditMode = !!id;
  const [show, setShow] = useState(false);
  const [expandedId, setExpandedId] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [totalPendingAmount, setTotalPendingAmount] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    collection_paid_date: new Date().toISOString().split("T")[0],
    area_id: "",
    customer_id: "",
    box_no: "",
    plan_id: "",
    entry_amount: "",
    staff_id: "",
    payment_method: "",
    total_pending_amount: 0,
    balance_amount: 0,
  });

  useEffect(() => {
    dispatch(fetchCollections(""));
  }, [dispatch]);

  // Edit Mode useEffect
  useEffect(() => {
    if (isEditMode && collections.length > 0) {
      const collection = collections.find((c) => c.collection_id === id);
      if (collection) {
        const newFormData = {
          collection_paid_date: collection.collection_paid_date,
          area_id: collection.area_id,
          customer_id: collection.customer_id,
          box_no: collection.box_no,
          plan_id: collection.plan_id,
          entry_amount: collection.entry_amount,
          staff_id: collection.staff_id,
          payment_method: collection.payment_method,
          total_pending_amount: collection.total_pending_amount,
          balance_amount:
            collection.total_pending_amount -
            (parseFloat(collection.entry_amount) || 0),
        };
        setFormData(newFormData);
        setSelectedCustomer(collection.customer_id);
        setSelectedArea(collection.area_id);
        setTotalPendingAmount(collection.total_pending_amount);
      }
    }
  }, [id, collections, isEditMode]);

  // Customer Selection useEffect
  useEffect(() => {
    if (isEditMode) {
      return;
    }
    if (selectedCustomer) {
      const customer = customers.find(
        (c) => c.customer_id === selectedCustomer
      );
      if (customer) {
        const pendingAmount = customer.total_pending_amount || 0;
        setTotalPendingAmount(pendingAmount);
        setFormData((prev) => ({
          ...prev,
          total_pending_amount: pendingAmount,
          balance_amount: pendingAmount - (parseFloat(prev.entry_amount) || 0),
        }));
      }
    } else {
      setTotalPendingAmount(0);
      setFormData((prev) => ({
        ...prev,
        total_pending_amount: 0,
        balance_amount: 0,
      }));
    }
  }, [selectedCustomer, customers, isEditMode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const updatedFormData = { ...prev, [name]: value };
      if (name === "entry_amount") {
        updatedFormData.balance_amount =
          parseFloat(prev.total_pending_amount || 0) - parseFloat(value || 0);
      }
      return updatedFormData;
    });
  };

  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    if (
      !formData.collection_paid_date ||
      !formData.area_id ||
      !formData.customer_id ||
      !formData.box_no ||
      !formData.plan_id ||
      !formData.entry_amount ||
      !formData.payment_method ||
      formData.total_pending_amount === undefined
    ) {
      NotifyData("All fields are required", "error");
      setIsSubmitting(false);
      return;
    }

    const collectionData = {
      ...formData,
      current_user_id: currentUserId,
      ...(isEditMode && { collection_id: id }),
    };

    try {
      const action = isEditMode ? updateCollection : addCollection;
      const msg = await dispatch(action(collectionData)).unwrap();
      NotifyData(msg, "success");
      navigate("/collection");
    } catch (error) {
      NotifyData(error.message, "error");
      setIsSubmitting(false);
    }
  };

  const handleOpen = () => setShow(true);
  const handleClose = () => {
    setShow(false);
  };

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const filteredCustomers = (() => {
    if (isEditMode) {
      return customers.filter((c) => c.customer_id === selectedCustomer);
    }
    if (selectedArea && selectedCustomer) {
      return customers.filter(
        (c) => c.area_id === selectedArea && c.customer_id === selectedCustomer
      );
    }
    if (selectedArea) {
      return customers.filter((c) => c.area_id === selectedArea);
    }
    if (selectedCustomer) {
      return customers.filter((c) => c.customer_id === selectedCustomer);
    }
    return customers;
  })();

  return (
    <div id="main">
      <Container fluid className="p-3">
        {!isEditMode && (
          <Row>
            <Col lg={3} md={8} className="p-3">
              <DropDown
                textlabel="Select Area"
                name="area_id"
                value={selectedArea}
                onChange={(e) => {
                  setSelectedArea(e.target.value);
                  setSelectedCustomer("");
                  setFormData({
                    ...formData,
                    area_id: e.target.value,
                    customer_id: "",
                    box_no: "",
                    plan_id: "",
                    staff_id: "",
                    payment_method: "",
                    total_pending_amount: 0,
                    balance_amount: 0,
                  });
                }}
                options={[{ value: "", label: "Select Area" }].concat(
                  areas.map((area) => ({
                    value: area.area_id,
                    label: area.area_name,
                  }))
                )}
              />
            </Col>
            <Col lg={3} md={8} className="p-3">
              <DropDown
                textlabel="Select Customer"
                name="customer_id"
                value={selectedCustomer}
                onChange={(e) => setSelectedCustomer(e.target.value)}
                options={[{ value: "", label: "Select Customer" }].concat(
                  (selectedArea
                    ? customers.filter((c) => c.area_id === selectedArea)
                    : customers
                  ).map((customer) => ({
                    value: customer.customer_id,
                    label: customer.name,
                  }))
                )}
              />
            </Col>
          </Row>
        )}
        <Container className="mt-4">
          {filteredCustomers.length > 0 ? (
            filteredCustomers.map((c) => {
              const fullPending = c.total_pending_amount || 0;
              const planPrize = c.plan_prize || 0;
              const due = Math.min(planPrize, fullPending);
              const totalPendingDisplay = Math.max(0, fullPending - planPrize);
              const isPaid = due === 0;

              return (
                <div key={c.customer_id} className="mb-3">
                  <Row className="align-items-center border rounded p-3">
                    <Col md={3} xs={12} className="mb-2 mb-md-0">
                      <h6 className="mb-0">{c.name}</h6>
                      <small className="text-muted">{c.phone}</small>
                    </Col>
                    <Col md={3} xs={12} className="mb-2 mb-md-0">
                      <big className="text-muted">{c.box_no}</big>
                    </Col>
                    <Col md={3} xs={12} className="text-md-center mb-2 mb-md-0">
                      <h6 className="mb-0">{c.plan_name}</h6>
                      <span className="text-success">{c.plan_prize}</span>
                    </Col>
                    <Col
                      md={3}
                      xs={12}
                      className="text-end d-flex justify-content-md-end justify-content-start"
                    >
                      <Button
                        variant="dark"
                        size="sm"
                        onClick={() => toggleExpand(c.customer_id)}
                      >
                        <FaCaretRight
                          className={`caret-icon ${
                            expandedId === c.customer_id ? "rotate-down" : ""
                          }`}
                        />
                      </Button>
                    </Col>
                  </Row>
                  <div
                    className={`transition-grid border ${
                      expandedId === c.customer_id ? "open" : "closed"
                    }`}
                  >
                    <Row className="row p-3">
                      <Col className="col-md-4 align-self-center">
                        <strong>Total Pending:</strong> {totalPendingDisplay}
                      </Col>
                      <Col className="col-md-4 d-flex justify-content-center align-self-center">
                        <strong>Due:</strong> {due}
                      </Col>
                      <Col className="col-md-4 text-end d-flex justify-content-end align-items-center">
                        <button
                          className={`paynow-btn ${isPaid ? "paid-btn" : ""}`}
                          onClick={() => {
                            const pendingAmount = isEditMode
                              ? formData.total_pending_amount
                              : c.total_pending_amount || 0;
                            setFormData({
                              ...formData,
                              customer_id: c.customer_id,
                              box_no: c.box_no,
                              plan_id: c.plan_id,
                              area_id: c.area_id || "",
                              staff_id: c.staff_id || "",
                              total_pending_amount: pendingAmount,
                              balance_amount:
                                pendingAmount -
                                (parseFloat(formData.entry_amount) || 0),
                            });
                            setTotalPendingAmount(pendingAmount);
                            setSelectedCustomer(c.customer_id);
                            handleOpen();
                          }}
                          disabled={isPaid}
                        >
                          <span className="icon">
                            <FaCreditCard />
                          </span>
                          <span className="text">
                            {isPaid ? "Paid" : "Pay Now"}
                          </span>
                        </button>
                      </Col>
                    </Row>
                  </div>
                </div>
              );
            })
          ) : (
            <div>No customer found for this collection.</div>
          )}
          <CustomModal
            show={show}
            setShow={setShow}
            pageTitle={
              isEditMode ? <>Edit Collection Details</> : <>Create Collection</>
            }
            showButton={true}
            submitButton={true}
            submitLabel={
              isSubmitting
                ? isEditMode
                  ? "Updating..."
                  : "Submitting..."
                : isEditMode
                ? "Update"
                : "Submit"
            }
            CancelLabel="Cancel"
            BodyComponent={
              <Container className="p-3">
                <Row className="mb-3">
                  <Col>
                    <label>Collection Date</label>
                  </Col>
                  <Col>
                    <Calender
                      initialDate={formData.collection_paid_date}
                      setLabel={(value) =>
                        setFormData({
                          ...formData,
                          collection_paid_date: value,
                        })
                      }
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <label>Total Pending Amount</label>
                  </Col>
                  <Col>
                    <TextInputform
                      type="number"
                      name="total_pending_amount"
                      value={formData.total_pending_amount}
                      disabled={true}
                      readOnly
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <label>Entry Amount</label>
                  </Col>
                  <Col>
                    <TextInputform
                      PlaceHolder="Entry amount"
                      name="entry_amount"
                      value={formData.entry_amount}
                      onChange={handleChange}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col>
                    <label>Payment Method</label>
                  </Col>
                  <Col>
                    <DropDown
                      name="payment_method"
                      value={formData.payment_method}
                      onChange={handleChange}
                      options={[
                        { value: "", label: "Select Payment Method" },
                        { value: "Cash", label: "Cash" },
                        { value: "Online", label: "Online" },
                        { value: "Kadai", label: "Kadai" },
                      ]}
                    />
                  </Col>
                </Row>
              </Container>
            }
            OnClick={handleSubmit}
            Size="md"
            disabled={isSubmitting}
            handleOpen={handleOpen}
            handleClose={handleClose}
          />
        </Container>
      </Container>
    </div>
  );
};

export default CollectionCreation;
